import {FabricCollection} from './FabricCollection';
import {Property} from './Property';
import {Fabric} from './Fabric';
import {FabricColor} from './FabricColor';
import { PartOption } from './Part';

export class Option {
  static OPTION_TYPE_OPTION = 'Option';
  static OPTION_TYPE_SELECT = 'Select';
  static OPTION_TYPE_FABRIC = 'Fabric';
  static OPTION_TYPE_PER_PRODUCT = 'Product';

  /**
   * Carpets & Rugs — which part of the carpet formula an option feeds.
   * Shape is flat once per unit, finishing is per linear metre of perimeter,
   * colour never affects the price (FR-010). Anything else is an ordinary option.
   */
  static CARPET_ROLE_SHAPE = 'shape';
  static CARPET_ROLE_FINISHING = 'finishing';
  static CARPET_ROLE_COLOUR = 'colour';

  public id: number;
  public name: string;
  public description: string;
  public type?: string;
  public fabricCollection?: FabricCollection|number;
  public fabricCollections: FabricCollection[] = [];
  public fabrics: Fabric[] = [];
  public fabric?: Fabric|number;
  public fabricColors?: FabricColor[] = [];
  public fabricColor?: FabricColor|number;
  public parent?: any;
  public firstParent?: any;
  public systemDescription: string;
  public priceMultiplier: Property|number;
  public code: string;
  public factoryCode: string;
  public required: boolean;
  public discounted?: boolean;
  public dealerPrice: number;
  public customerPrice: number;
  public status: string;
  public position?: string;
  public parentPosition?: number;
  public translations: any;
  public translationEntries ?= {};
  public translationKeys ?= [];
  public options?: Option[];
  public urbanOption?: Option;
  public products?: number[];
  public deleted?: boolean;
  public typePerProduct?: string;
  public needsFabric: boolean;
  public fabricAmount?: number;
  public hasProductionForms?: boolean;
  public partOptions?: PartOption[];
  /**
   * The option requires the end customer's details before the order can be placed
   * (POS insurance). Set by US-607 on the four POS options, so the order screen never
   * has to know a hardcoded POS option-group id.
   */
  public requiresCustomerDetails?: boolean;
  /**
   * POS insurance term in years, and whether the option covers electrical furniture.
   * Explicit configuration (POS-D08) - PosOptionTermResolver refuses to infer either from
   * the option's name, and the POS overview and the Layout 7 export both fail until they
   * are set on the option form.
   */
  public posTermYears?: number;
  public posIsElectrical?: boolean;
  public carpetRole?: string;
  constructor() {
    this.translations = [];
  }
}
